export * as tableReservations from '@wix/auto_sdk_table-reservations-experiences_table-reservations/meta';
